<template>
  <div>
    <v-navigation-drawer :value="drawer" app @transitionend="ShowEvent">
      <IphLogo />
      <v-divider></v-divider>
      <AvatarUser v-if="GET_user" />

      <v-divider></v-divider>

      <v-list dense nav>
        <v-list-item link :to="{ name: 'home' }" color="red darken-2">
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Página Inicial</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list-group prepend-icon="mdi-account" color="red darken-2">
        <template dense v-slot:activator>
          <v-list-item dense class="ml-0 pl-0">
            <v-list-item-title color="red lighten-1">Escalas</v-list-item-title>
          </v-list-item>
        </template>

        <v-list dense nav class="ml-5 pl-5">
          <v-list-item link :to="'/scale'" color="red lighten-1">
            <v-list-item-icon>
              <v-icon>mdi-account-group</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Nova escala</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link :to="'/swaps'" color="red lighten-1">
            <v-list-item-icon>
              <v-icon>mdi-swap-horizontal</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Trocas de Escalas</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-list-group>

      <v-divider></v-divider>

      <v-list-group prepend-icon="mdi-message-bulleted" color="red darken-2">
        <template dense v-slot:activator>
          <v-list-item dense class="ml-0 pl-0">
            <v-list-item-title color="red lighten-1">Comunicação Interna</v-list-item-title>
          </v-list-item>
        </template>

        <v-list dense nav class="ml-5 pl-5">
          <v-list-item link :to="'/ci/received'" color="red lighten-1">
            <v-list-item-icon>
              <v-icon>mdi-email</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Recebidos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link :to="'/ci/sended'" color="red lighten-1">
            <v-list-item-icon>
              <v-icon>mdi-send</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Enviados</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-list-group>

      <template v-slot:append>
        <div class="pa-2">
          <v-btn class="menu-bg-gradinte-iph-red white--text" block @click="ActionSignOut"
            >Sair</v-btn
          >
        </div>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
import IphLogo from './IphLogo'
import AvatarUser from './AvatarUser'

import { mapGetters, mapActions, mapState } from 'vuex'

export default {
  name: 'MainMenu',
  data: function () {
    return {
      verify: true,
      inset: false,
      model: 0,
      menuRh: false,
      menuComunication: false,
      menuEcommerce: false,
      menuCourse: false,
      menuUsers: false,
      activeEmploeeMenu: true,
      activeLinkText: '',
      // activeCurrentPage: 'router-link-active',
      admins: [
        ['Management', 'mdi-home'],
        ['Settings', 'mdi-home'],
      ],
      cruds: [
        ['Create', 'add'],
        ['Read', 'insert_drive_file'],
        ['Update', 'update'],
        ['Delete', 'delete'],
      ],
    }
  },
  components: {
    IphLogo,
    AvatarUser,
  },
  computed: {
    ...mapState('menu', ['drawer']),
    ...mapGetters('auth', ['GET_user']),
  },
  methods: {
    ...mapActions('auth', ['ActionSignOut']),
    ...mapActions('menu', ['ActionSetDrawerFalse', 'ActionSetDrawerTrue']),
    ShowEvent(e) {
      let a = e.propertyName
      if (a == 'visibility' && this.verify) {
        this.ActionSetDrawerFalse()
        this.verify = false
      } else if (a == 'visibility' && !this.verify) {
        this.ActionSetDrawerTrue()
        this.verify = true
      }
    },
  },
}
</script>
